import _ from 'underscore';

export function reducer(state, action) {
  const { type, payload } = action;
  switch (type) {
    case 'START_LOAD_DATA':
      return {
        ...state,
        items: null,
      };
    case 'FINISH_LOAD_DATA':
      return {
        ...state,
        items: payload.items.map(item => (
          _.some(state.selectedItems, selected => selected.id === item.id) ?
            { ...item, isSelected: true } : { ...item, isSelected: false }
        )),
        totalCount: payload.totalCount,
      };
    case 'SET_ITEM_FILTER':
      return {
        ...state,
        search: payload,
        pageNumber: 1,
        totalCount: null,
      };
    case 'SET_SELECTED_ITEM_FILTER':
      return {
        ...state,
        selectionSearch: payload,
      };
    case 'UPDATE_PAGE_NUMBER':
      return {
        ...state,
        pageNumber: payload,
      };
    case 'SELECT_ALL':
    {
      const newlySelectedItems = state.items.filter(item => !_.some(state.selectedItems, selected => selected.id === item.id))
        .map(item => ({ id: item.id, name: item.name }));

      return {
        ...state,
        items: state.items.map(item => ({ ...item, isSelected: true })),
        selectedItems: [...state.selectedItems, ...newlySelectedItems],
      };
    }
    case 'SELECT_ITEM':
      return {
        ...state,
        items: state.items.map(item => (item.id === payload.id ? { ...item, isSelected: true } : item)),
        selectedItems: [...state.selectedItems, { id: payload.id, name: payload.name }],
      };
    case 'SET_SELECTED_ITEMS':
      return {
        ...state,
        selectedItems: payload,
        items: state.items.map(item => (
          _.some(payload, selected => selected.id === item.id) ?
            { ...item, isSelected: true } : { ...item, isSelected: false }
        )),
      };
    case 'DESELECT_ITEM':
      return {
        ...state,
        items: state.items.map(item => (item.id === payload.id ? { ...item, isSelected: false } : item)),
        selectedItems: state.selectedItems.filter(item => item.id !== payload.id),
      };
    case 'DESELECT_ITEMS': {
      const selectedItems = state.selectedItems.filter(item => !_.some(payload, deSelected => deSelected.id === item.id));
      const items = state.items.map(item => (_.some(selectedItems, selected => selected.id === item.id) ? item : { ...item, isSelected: false }));

      return {
        ...state,
        items,
        selectedItems,
      };
    }
    default:
      return state;
  }
}

